import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCatalogStructure } from '../api';

function StatesPage() {
  const navigate = useNavigate();
  const [catalog, setCatalog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getCatalogStructure()
      .then((data) => {
        if (!cancelled) {
          setCatalog(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'Failed to load catalog');
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  const states = useMemo(() => {
    if (!catalog) return [];
    return catalog.states || [];
  }, [catalog]);

  return (
    <div className="browse-page-container">
      <div className="browse-page-header">
        <h1 className="browse-page-title">Browse by State</h1>
        <p className="browse-page-subtitle">
          Select a state to explore its grade levels and start a practice session.
        </p>
      </div>

      {loading && (
        <div className="browse-loading">
          <div className="browse-loading-spinner" />
          <span>Loading states…</span>
        </div>
      )}

      {error && <div className="error">{error}</div>}

      {!loading && !error && states.length === 0 && (
        <div className="browse-empty">No states found.</div>
      )}

      {!loading && !error && (
        <div className="grade-level-cards-grid">
          {states.map((state) => {
            const gradeCount = state.gradeCount || (state.gradeLevels || []).length;
            return (
              <button
                key={state.name}
                type="button"
                className="grade-level-card"
                onClick={() => navigate(`/state/${encodeURIComponent(state.name)}`)}
              >
                <span className="grade-level-card-name">{state.name}</span>
                <span className="grade-level-card-count">
                  {gradeCount} grade{gradeCount !== 1 ? 's' : ''}
                </span>
                <span className="grade-level-card-arrow">→</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default StatesPage;
